<template>
  <div
    class="h-full relative "
    :class="{'dark' : isDarkTheme}"
  >
    <div v-if="cannotConfig" class="h-full flex flex-col justify-center items-center">
      <h5 class="font-bold text-lg">
        Presentation's already set!
      </h5>
      <p class="w-96 text-center text-base">
        If you want to show another presentation, ask the presenter or add a new AhaSlides tab.
      </p>
    </div>
    <div v-else>
      <div v-if="!isLoggedIn">
        <MSTeamsAuth @loginSuccess="onLoginSuccess" />
      </div>
      <div v-else>
        <div
          v-if="isPickedPresentation"
          class="flex flex-col justify-center align-middle h-screen text-center"
        >
          <aha-link
            class="absolute top-4 left-4"
            @click="onClickBackToList"
            :class="{'dark': isDarkTheme}"
          >
            <span
              class="icon"
            >
              <aha-icon
                name="arrow-no-tail"
                height="16"
              />
            </span>
            <aha-icon />

            Back
          </aha-link>
          <div>
            <h2 class="mb-5 text-2xl">
              You’re all set
            </h2>
            <img class="image-guide m-auto" src="@/assets/images/ms-teams/guide.png" />
            <p class="text-center text-guide mt-8 mb-2">
              Save to finish setting up and start interacting!
            </p>
          </div>
        </div>
        <div v-else>
          <MSTeamsPresentationsList
            @logout="onLogout"
            @selectPresentation="onSelectPresentation"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { app, pages } from '@microsoft/teams-js'
import { mapState, mapActions } from 'vuex'
import cookie from '@/services/cookie'
import utils from '@/util'

import msTeamsUtils from '@/utils/ms-teams'
import MSTeamsAuth from './MSTeamsAuth.vue'
import MSTeamsPresentationsList from './MSTeamsPresentationsList.vue'
import EventBus from '@/eventBus'

export default {
  name: 'TabConfig',
  components: {
    MSTeamsAuth,
    MSTeamsPresentationsList,
  },
  props: {

  },
  data() {
    return {
      isLoggedIn: false,
      cannotConfig: false,
      isPickedPresentation: false,
      isDarkTheme: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
  },
  async created() {
    const isDarkTheme = await msTeamsUtils.isDarkThemeInMsTeams()

    this.isDarkTheme = isDarkTheme
  },

  async mounted() {
    EventBus.$on('ms-teams-login-success', this.onLoginSuccess)
    const token = cookie.getValue('ahaToken')
    this.isLoggedIn = !!token

    const isTabOwner = await this.checkTabOwner()
    if (!isTabOwner) {
      this.cannotConfig = true
      return
    }

    const frameContext = app.getFrameContext()
    if (frameContext === 'settings') {
      pages.config.setValidityState(false)
    }
  },
  destroyed() {
    EventBus.$off('ms-teams-login-success')
  },
  methods: {
    ...mapActions([
      'setCurrentUserAction',
    ]),
    async checkTabOwner() {
      const context = await app.getContext()
      if (!context || !context.page || !context.page.id) return true
      const entityId = context.page.id
      const presentationConfig = msTeamsUtils.decodeEntityId(entityId)

      const { msTeamsUserId, ahaslidesUserId } = presentationConfig
      return msTeamsUserId === context.user.id ||
        ahaslidesUserId === this.currentUser.id
    },

    onLogout() {
      utils.setCookieToken('')
      utils.cleanUserCookies()
      this.setCurrentUserAction({})
      this.isLoggedIn = false
      utils.mixpanelTracking('Presentation List', 'Logout', null, null, {
        isMSTeamsApp: true,
      })
    },
    onLoginSuccess(token) {
      Vue.http.headers.common.Authorization = `Bearer ${token}`
      this.isLoggedIn = true
    },
    onClickBackToList() {
      this.isPickedPresentation = false
    },
    async onSelectPresentation(presentation) {
      const frameContext = app.getFrameContext()

      if (presentation && presentation.id) {
        if (frameContext === 'settings') {
          this.isPickedPresentation = true

          pages.config.registerOnSaveHandler(async (saveEvent) => {
            try {
              await msTeamsUtils.setPresentContext(presentation)
              saveEvent.notifySuccess()
            } catch (e) {
              saveEvent.notifyFailure()
            }
          })

          pages.config.setValidityState(true)
        } else {
          await msTeamsUtils.setPresentContext(presentation)
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.icon {
  transform: rotateY(180deg);
  padding-left: 5px;
}
.image-guide {
  width : 85%;
}
.text-guide{
  font-size: 16px;
}

.dark {
  background:  black;
  color : #AFAFAF;
  h2,h3,p {
    color : #AFAFAF;
  }
  .text-secondary-100{
    color: #AFAFAF;
  }
  .text-base-80{
    color : #AFAFAF;
  }
  // write css for data contribute

  path {
    fill: white!important;
}
}
.dark-folder {
  background:  #313131;
  border: 1px solid #3F4557;
  .text-dark-theme {
    color : #AFAFAF;
  }
  .text-light-in-dark-theme{
    color : white;
  }
}
</style>
